// API base URL — uses Vite env variable in production, falls back to /api for local dev proxy
export const API_BASE = import.meta.env.VITE_API_URL || '/api';
